import React from 'react';
import { injectIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { toolbarInsertBlockMessages } from '@atlaskit/editor-common/messages';
import { TOOLBAR_BUTTON, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import VideoCircleIcon from '@atlaskit/icon/glyph/video-circle';
import { recordVideo } from '../commands';
var LoomToolbarButton = function LoomToolbarButton(_ref) {
  var disabled = _ref.disabled,
    api = _ref.api,
    formatMessage = _ref.intl.formatMessage;
  var _useSharedPluginState = useSharedPluginState(api, ['loom']),
    loomState = _useSharedPluginState.loomState;
  if (!loomState) {
    return null;
  }
  var label = formatMessage(toolbarInsertBlockMessages.recordVideo);
  return /*#__PURE__*/React.createElement(ToolbarButton, {
    buttonId: TOOLBAR_BUTTON.RECORD_VIDEO,
    onClick: function onClick() {
      var _api$core, _api$analytics;
      return api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(recordVideo({
        inputMethod: INPUT_METHOD.TOOLBAR,
        editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions
      }));
    }
    // Disable the icon while the SDK isn't initialised
    ,
    disabled: disabled || !(loomState !== null && loomState !== void 0 && loomState.isEnabled),
    title: label,
    iconBefore: /*#__PURE__*/React.createElement(VideoCircleIcon, {
      label: label
    })
  });
};
export default injectIntl(LoomToolbarButton);